import { useState, useEffect } from 'react'
import axios from 'axios'

export const useSystemConfig = (configKey = null) => {
  const [config, setConfig] = useState(configKey ? null : [])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadConfig()
  }, [configKey])

  const loadConfig = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem('sgc_token')
      
      if (configKey) {
        // Obtener una configuración específica
        const response = await axios.get(`/api/config/${configKey}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        setConfig(response.data)
      } else {
        // Obtener todas las configuraciones
        const response = await axios.get('/api/config', {
          headers: { Authorization: `Bearer ${token}` }
        })
        
        if (Array.isArray(response.data)) {
          setConfig(response.data)
        } else {
          setConfig([])
          setError('Formato de datos incorrecto del servidor')
        }
      }
    } catch (error) {
      console.error('Error al cargar configuración:', error)
      setConfig(configKey ? null : [])
      setError(error.response?.data?.detail || error.message || 'Error al cargar configuración')
    } finally {
      setLoading(false)
    }
  }

  const refreshConfig = () => {
    loadConfig()
  }

  return {
    config,
    loading,
    error,
    refreshConfig
  }
}

// Hook específico para el logo del sistema
export const useSystemLogo = () => {
  const { config: logoConfig, loading, error } = useSystemConfig('sistema.logo_url')
  
  const logoUrl = logoConfig?.valor || '/ensas_logo.png' // Fallback al logo por defecto
  
  return {
    logoUrl,
    loading,
    error
  }
}